import React from 'react'
import {Header, Footer, Tabs} from './Index';
import { useAppSelector } from '../store/hooks';

const Layout = (props:any) => {
    const darkMode = useAppSelector((state:any) => state.categoryNavigation.darkmode); 
    const activeTab = useAppSelector((state:any) => state.categoryNavigation.activetab); 
    const activeCategory = useAppSelector((state:any) => state.categoryNavigation.activecategory);
    const fontSize = useAppSelector((state:any) => state.categoryNavigation.fontsize); 
    const loading = useAppSelector((state:any) => state.categoryNavigation.loading);    
    const getdevice = useAppSelector((state: any) => state.getPlatformSlice.data);
  return (
    <div className={`font-sans min-h-screen ${getdevice == 'android' && 'pt-12'} ashok-test ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>       
        <Header activeCategory={activeCategory}
            darkMode={darkMode}/>
            {props.children}
        <Footer activeTab={activeTab}
            darkMode={darkMode}/>
        <Tabs activeTab={activeTab}
            darkMode={darkMode}
            fontSize={fontSize}
            loading={loading}
        />   
    
    </div>
  )
}

export default Layout
